export const ASSORTMENTS_MANAGEMENT = {
    NEW_BUYER: "new-buyer",
    NEW_SUPERUSER: "new-superuser",
    USER_SEARCH_FIELD: "user-search-field",
    BUYER_INFORMATION: {
        NAME: "name",
        EMAIL: "email",
        ACCESS: "access",
        LAST_LOGIN: "last-login",
    },
    SUPERUSER_INFORMATION: {
        NAME: "name",
        EMAIL: "email",
        ACCESS: "access",
        LAST_LOGIN: "last-login",
    },
    EDIT_USER: "edit-user",
    TOGGLE_MERCHANT_ACCESS: "toggle-merchant-access",
    TOGGLE_ASSORTMENT_ACCESS: "toggle-assortment-access",
    GRANT_ACCESS: "grant-access",
    REVOKE_ACCESS: "revoke-access",
};
